import React, { useEffect, useRef, useState } from "react";
import { createCountry, getStatus } from "../../Services/MasterService";
import { toast } from "react-toastify";
import { toBase64 } from "../../Services/commonHelper";

const AddCountry = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: null,
        name: null,
        alias: null,
        phone_code: null,
        status: null,
        logo: null,
        flag: null,
        country_code: null,
        display_order: null,
        continent_ref_id: null,
        currency_ref_id: null,
    });
    const [loader, setLoader] = useState(false);
    const [status, setStatus] = useState([]);
    const uploadRef = useRef(null);
    const uploadLogoRef = useRef(null);

    const [previewImage, setPreviewImage] = useState({
        logo: "",
        flag: ""
    });

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleImport = async (e, field) => {
        const file = e.target.files[0];
        e.target.value = "";
        if (file?.type?.includes("image/jpeg") || file?.type?.includes("image/png")) {
            let base64String = await toBase64(file);
            handleChange(field, base64String);
            setPreviewImage({ ...previewImage, [field]: URL?.createObjectURL(file) });
        } else {
            toast.error("Image must ba valid .jpeg file")
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isNotAllowed = Boolean(Number(reqData.status) == 0 || isNaN(Number(reqData.status)));
        if (isNotAllowed) {
            toast.error("Status is required");
        } else {
            setLoader(true);
            let { ok } = await createCountry(reqData);
            if (ok) {
                toast.success("Success");
                onCloseWithApi();
            }
            setLoader(false);
        }
    };

    const getStatusCall = async () => {
        let { ok, data } = await getStatus({});
        if (ok) {
            setStatus(data?.records);
        }
    };

    useEffect(() => {
        getStatusCall();
        if (data?.data) {
            const { name, alias, flag, phone_code, status, logo, id, country_code, display_order, continent_ref_id, currency_ref_id } = data?.data;
            setReqData({ name, alias, flag, phone_code, status, logo, id, country_code, display_order, continent_ref_id, currency_ref_id });
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Country" : "Edit Country"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                required
                                                value={reqData?.name}
                                                onChange={(e) => handleChange("name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Alias</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Alias"
                                                required
                                                value={reqData?.alias}
                                                onChange={(e) => handleChange("alias", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Phone Code</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Phone Code"
                                                required
                                                value={reqData?.phone_code}
                                                onChange={(e) => handleChange("phone_code", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Country Code</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Country Code"
                                                required
                                                value={reqData?.country_code}
                                                onChange={(e) => handleChange("country_code", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Display Order</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Display Order"
                                                required
                                                value={reqData?.display_order}
                                                onChange={(e) => handleChange("display_order", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Continent Ref ID</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Continent Ref ID"
                                                required
                                                value={reqData?.continent_ref_id}
                                                onChange={(e) => handleChange("continent_ref_id", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Currency Ref ID</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Currency Ref ID"
                                                required
                                                value={reqData?.currency_ref_id}
                                                onChange={(e) => handleChange("currency_ref_id", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Status</label>
                                            <select required value={reqData?.status_id} onChange={(e) => handleChange("status", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Status</option>
                                                {status?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="mb-3 d-flex bank-details-btn">
                                            <div>
                                                <button onClick={(e) => { e.preventDefault(); uploadRef?.current?.click() }} className={`btn bank-save-btn`}>
                                                    {reqData?.flag ? "Change Flag" : "Add Flag"}
                                                </button>
                                            </div>
                                            {Boolean(previewImage?.flag || reqData?.flag) && <img
                                                width={75}
                                                class="mx-3 img-thumbnail"
                                                alt="Flag Image"
                                                src={previewImage?.flag ? previewImage?.flag : reqData?.flag}
                                            />}
                                        </div>
                                        <div className="mb-3 d-flex bank-details-btn">
                                            <div>
                                                <button onClick={(e) => { e.preventDefault(); uploadLogoRef?.current?.click() }} className={`btn bank-save-btn`}>
                                                    {reqData?.logo ? "Change Logo" : "Add Logo"}
                                                </button>
                                            </div>
                                            {Boolean(previewImage?.logo || reqData?.logo) && <img
                                                width={75}
                                                class="mx-3 img-thumbnail"
                                                alt="Flag Image"
                                                src={previewImage?.logo ? previewImage?.logo : reqData?.logo}
                                            />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <input hidden ref={uploadRef} type="file" name="upload" id="upload" onChange={(e) => handleImport(e, "flag")} />
            <input hidden ref={uploadLogoRef} type="file" name="upload" id="upload" onChange={(e) => handleImport(e, "logo")} />
        </div>
    );
};

export default AddCountry;